// src/CoPilotChat.jsx
import React, { useEffect, useState, useRef, useMemo } from "react";

//const DIRECT_LINE_TOKEN_ENDPOINT = "https://api.houstonisd.org/ChatBotTokenService/api/directline/token";

// Ensure WebChat is available globally if using CDN
// You would typically include this in your public/index.html
// <script src="https://cdn.botframework.com/botframework-webchat/latest/webchat.js"></script>

/*using node server  -USE THIS UNTIL WE DECIDE TO PUBLISH TO DIFFERENT ENVIRONMENTS*/
//const DIRECT_LINE_TOKEN_ENDPOINT = 'http://localhost:3001/api/directline/token'; // Your backend endpoint

/*usig web api - HISD - THIS WILL CHANGE WHEN GOING TO PRODUCTION
const DIRECT_LINE_TOKEN_ENDPOINT =
  "https://api.houstonisd.org/TransportationChatTokenServiceINT/api/directline/token";
   */

/* -USE BELOW FOR PRODUCTION  
const DIRECT_LINE_TOKEN_ENDPOINT =
   "https://api.houstonisd.org/TransportationChatTokenServicePROD/api/directline/token";
 
*/

  /*AZURE -- BELOW IS WHAT IS FOR ASKIT PRODUCTION
const DIRECT_LINE_TOKEN_ENDPOINT =
  "https://api-askit-dev.azurewebsites.net/api/AskIT/token";
  -DEV*/

/* USE BELOW FOR AZURE*/
const DIRECT_LINE_TOKEN_ENDPOINT =
   "https://api-asktransportation-prod-bse5gmc9bvevaghk.southcentralus-01.azurewebsites.net/api/directline/token";
 


const CoPilotChat = ({
  userId = "YourCustomUserID_React",
  userName = "React User",
}) => {
  const [directLineToken, setDirectLineToken] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const webChatRef = useRef(null);

  // --- All your existing logic for fetching tokens, etc. remains the same ---
  useEffect(() => {
    const fetchToken = async () => {
      try {
        const response = await fetch(DIRECT_LINE_TOKEN_ENDPOINT, {
          method: "POST",
        });
        if (!response.ok)
          throw new Error(
            `Failed to fetch Direct Line token: ${response.status}`
          );
        const data = await response.json();
        setDirectLineToken(data.token);
        setIsLoading(false);
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };
    fetchToken();
  }, []);

  const directLine = useMemo(
    () =>
      directLineToken
        ? window.WebChat.createDirectLine({ token: directLineToken })
        : null,
    [directLineToken]
  );

  const store = useMemo(() => {
    if (!window.WebChat) return null;

    return window.WebChat.createStore(
      {}, // initial state
      ({ dispatch }) =>
        (next) =>
        (action) => {
          // This is the middleware where we can "spy" on actions

          //console.log('Web Chat Action:', action);

          // Auto-start the conversation once Direct Line connects
          if (action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
            dispatch({
              type: "WEB_CHAT/SEND_POST_BACK",
              payload: {
                value: "__INTERNAL_START_CONVERSATION__", // The secret trigger phrase
              },
            });
          }

          // Pass the action along so Web Chat continues to work normally
          return next(action);
        }
    );
  }, []); // The dependency array can remain empty

  useEffect(() => {
    if (directLine && store && webChatRef.current && window.WebChat) {
      window.WebChat.renderWebChat(
        {
          directLine,
          store,
          userID: userId,
          username: userName,
          locale: "en-US",
          styleOptions: {
            botAvatarInitials: "CP",
            userAvatarInitials: userName
              ? userName.substring(0, 1).toUpperCase()
              : "U",
            bubbleBackground: "#f0f0f0",
            bubbleFromUserBackground: "#d1eaff",
            suggestedActionBackground: "white",
            backgroundColor: "white",
            hideUploadButton: true,
            sendBoxButtonColor: "#17a2a0",
            sendBoxBorderTop: "solid 1px #e2eceb",
            sendBoxHeight: 56,
          },
        },
        webChatRef.current
      );
    }
  }, [directLine, store, userId, userName]);
  // --- End of unchanged logic ---

  return (
    <div className="hisd-body">
      <div className="hisd-welcome-col">
        <h1 className="hisd-welcome-title">
          Welcome to the
          <br />
          <span className="hisd-teal-text">AskTransportation Agent</span>
        </h1>
        <p className="hisd-welcome-subtitle">
          Your virtual assistant is here to help with bussing information,
          safety, and enrollment questions—anytime you need it.
        </p>

        <div className="hisd-card">
          <div className="hisd-card-icon">
            <i className="fa-solid fa-bus"></i>
          </div>
          <div className="hisd-card-body">
            <div className="hisd-card-title">Track Your Child's Bus</div>
            <div className="hisd-card-desc">
              Get real-time updates with the SmartTag Parent App.
            </div>
            <a
              className="hisd-card-link"
              href="https://www.qbit.codes/q/smart-tag-parent-app"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download the SmartTag App &rarr;
            </a>
          </div>
        </div>

        <div className="hisd-card">
          <div className="hisd-card-icon">
            <i className="fa-solid fa-shield-alt"></i>
          </div>
          <div className="hisd-card-body">
            <div className="hisd-card-title">Report a Safety Concern</div>
            <div className="hisd-card-desc">
              Let us know about any safety concerns.
            </div>
            <a
              className="hisd-card-link"
              href="https://portal.laserfiche.com/a6882/forms/TSRFParent"
              target="_blank"
              rel="noopener noreferrer"
            >
              Report Now &rarr;
            </a>
          </div>
        </div>

        <div className="hisd-card">
          <div className="hisd-card-icon">
            <i className="fa-solid fa-file-lines"></i>
          </div>
          <div className="hisd-card-body">
            <div className="hisd-card-title">New to HISD?</div>
            <div className="hisd-card-desc">
              Start the enrollment process.
            </div>
            <a
              className="hisd-card-link"
              href="https://apps.hisd-survey.org/surveys/enrollment"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn More &rarr;
            </a>
          </div>
        </div>

        <div className="hisd-card">
          <div className="hisd-card-icon">
            <i className="fa-solid fa-circle-question"></i>
          </div>
          <div className="hisd-card-body">
            <div className="hisd-card-title">Ask a Question</div>
            <div className="hisd-card-desc">
              Type your question in the chat and we'll help.
            </div>
          </div>
        </div>

        <div className="hisd-card hisd-card-highlight">
          <div className="hisd-card-icon hisd-card-icon-light">
            <i className="fa-solid fa-location-arrow"></i>
          </div>
          <div className="hisd-card-body">
            <div className="hisd-card-title">We're here for you 24/7.</div>
            <div className="hisd-card-desc">
              Real answers. Real support. Real time.
            </div>
          </div>
        </div>
      </div>

      <div className="hisd-chat-col">
        <div className="hisd-chat-panel">
          <div className="hisd-chat-header">AskTransportation Agent</div>
          <div className="hisd-chat-mount" id="webchat-react-container">
            <div
              ref={webChatRef}
              style={{
                flexGrow: 1,
                overflowY: "auto",
              }}
            />
            {isLoading && (
              <div className="hisd-chat-status">
                <span className="hisd-spinner"></span>
                Connecting...
              </div>
            )}
            {error && (
              <div className="hisd-chat-status hisd-chat-status-error">
                Unable to connect: {error}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoPilotChat;
